import * as service from './chemicalsettings.service.js'
export default {
  data() {
    return {
      Chemicalcolumns: ['Name', 'IsActive', 'Actions'],
      optionstable: {
        headings: {IsActive: 'Active', Name: 'Template Name', Actions: ''},
        filterable: true,
        sortable: ['Name'],
        sortIcon: this.$hydrowareCommonJS.SortIcons,
        orderBy: {ascending: true},
        texts: {filterPlaceholder: this.$hydrowareCommonJS.SearchFieldPlaceHolder}
      },
      templates: [], //FG - FOOF - This will hold the readings and tasks templates
      //StateName: '', //FG - FOOF - remove this when you are convinced it does nothing
      ////////IsActive: false,//FG - FOOF - remove this when you are convinced it does nothing
      //checked: {}, //FG - FOOF - remove this when you are convinced it does nothing
      itemsSelected: '',
      isEmpty: false,
      idList: [],
      //Locations: [], //FG - FOOF - remove this when you are convinced it does nothing
      locationName: '',
      //templateData: {LocationId: '', isEdit: false, tid: ''},vvvvvv
      templateData: {LocationId: '', isEdit: false, templateId: ''},
      locationId: '',
      LocationPools: [],
      //LocationPoolsBackup: [], //FG - FOOF - remove this when you are convinced it does nothing
      //checklistsBackup: [], //FG - FOOF - remove this when you are convinced it does nothing 
      //viewChemical: true, //FG - FOOF - remove this when you are convinced it does nothing 
      activatedPoolIds: [],
      editChemical: false,
      chemChecklists: [],
      checklists: [],
      //locationNamesel: '', //FG - FOOF - remove this when you are convinced it does nothing
      displayingTabbedPanes: false,
    }
  },
  mounted() {
    let context = this
    this.$router.app.$on('emittedlocation_obj', (data) => {
      context.locationId = data.LocationId ? data.LocationId : ''
      context.locationName = data.LocationName ? ' - ' + data.LocationName: ''
      if (context.locationId) {
        context.templateData.LocationId = context.locationId
        context.GetTemplates(context.locationId)
        context.$router.app.$emit('hydroware_changelocationname', data.LocationName)
      }
    })
    this.$router.app.$on('hydroware_readingsTemplateSaved', (data) => {
      context.GetTemplates(context.locationId)
      this.isediting = false
      this.displayingTabbedPanes = false
    });
    let seltoggletrue = false
    $('#sel_toggler').on('click', function () {
      if ($(this.parentElement).hasClass('is-checked')) {
        $(this.parentElement).removeClass('is-checked')
        context.activatedPoolIds = []
        context.LocationPools.map(function (el) {
        })
      } else {
        $(this.parentElement).addClass('is-checked')
        context.activatedPoolIds = []
        context.LocationPools.map(function (el) {
          el['rowChecked'] = true
        })
      }
    })
  },
  beforeDestroy() {
    this.$root.$off('hydroware_readingsTemplateSaved')
  },
  methods: {
    showTemplatevit() {
      this.displayingTabbedPanes = false
    },
    displayAddTemplatePage() {
            //FG - FOOF - Jan 23 2019 - I added "this" (which is this instance of
      //     chemicalsettings.controller.js) the template data that is passed
      //     along to the readings_maintenance.controller.js and 
      //     readings_maintenance.vue files so we have access to all of its
      //     functions and variables.
      this.templateData.chemsettingscontroller = this
      this.$router.app.$emit('is_add') //LOOK HERE - zzzzzz
      this.displayingTabbedPanes = true
      this.templateData.isEdit = false
    },
    deleteMeasureTemp(id) {
      let context = this
      if (id) {
        this.chemChecklists.map(function (el) {
          if (el.Id == id) {
            el['UI_Flag'] = false
          }
        })
        this.chemChecklists.map(function (el, index) {
          if (el.Id == id) {
            context.chemChecklists.splice(index, 1)
            context.ChemicalForm.Chemicals.splice(index, 1)
          }
        })
      }
      this.checkChemicalsnull(this.ChemicalForm.Chemicals)
    },
    toggleRowPools(row) {
      let pool = row.LocationPools
      let context = this
      for (var i = 0; i < context.LocationPools.length; i++) {
        if (row.LocationId == context.LocationPools[i].LocationId) {
          if (row.rowChecked == true) {
            context.LocationPools[i]['rowChecked'] = true
          } else {
            context.LocationPools[i]['rowChecked'] = false
          }
        }
      }
      if (pool.length > 0) {
        pool.map(function (el) {
          context.LocationPools.map(function (hl, ind) {
            hl.LocationPools.map(function (vl, index) {
              if (el.PoolId == hl.LocationPools[index].PoolId) {
                if (context.LocationPools[ind].rowChecked == true) {
                  vl['IsActive'] = true
                  context.activatedPoolIds.push(el.PoolId)
                } else {
                  vl['IsActive'] = false
                  if (context.activatedPoolIds.length > 0) {
                    if (context.activatedPoolIds.indexOf(el.PoolId) > -1) {
                      context.activatedPoolIds.splice(context.activatedPoolIds.indexOf(el.PoolId), 1)
                    }
                  }
                }
              }
            })
          })
        })
      }
    },
    toggleActivatepool(poolid) {
      let context = this
      this.LocationPools.map(function (el) {
        el['LocationPools'].map(function (hl) {
          if (hl.PoolId == poolid) {
            if (hl.IsActive == true) {
              hl['IsActive'] = false
              if (context.activatedPoolIds.length > 0) {
                if (context.activatedPoolIds.indexOf(poolid) > -1) {
                  context.activatedPoolIds.splice(context.activatedPoolIds.indexOf(poolid), 1)
                }
              }
            } else {
              hl['IsActive'] = true
              context.activatedPoolIds.push(poolid)
            }
          }
        })
      })
    },
    toggleActivateButton(data) {
      let context = this
      let activateids = []
      window.xp = deepcopy(this.templates)
      this.templates.map(function (el) {
        if (el.Id == data.Id) {
          if (el.IsActive == true) {
            el['IsActive'] = false
          } else {
            el['IsActive'] = true
          }
          activateids.push({
            Id: data.Id,
            IsActive: el.IsActive
          })
          context.toggleActivate(activateids)
        }
      })
    },
    activateSelected() {
      let activateids = []
      this.idList.forEach(function (id) {
        activateids.push({
          Id: id,
          IsActive: true
        })
      })
      this.toggleActivate(activateids)
    },
    deactivateSelected() {
      let activateids = []
      this.idList.forEach(function (id) {
        activateids.push({
          Id: id,
          IsActive: false
        })
      })
      this.toggleActivate(activateids)
    },
    toggleActivate(data) {
      let context = this
      context.$confirm('Are you sure you want to Activate / Deactivate this template ?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        loader.startLoader()
        service.ActivateChemicalChecklist(data).then(function (response) {
          
        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {
          loader.stopLoader()
          return;
        }

          loader.stopLoader()
          context.itemsSelected = 0
          context.GetTemplates(context.locationId)
          $('#main_toggler').parent().removeClass('is-checked')
        }, (error) => {
          loader.stopLoader()
          this.$notify({
            title: 'Error',
            message: error.responseJSON.Message,
            type: 'error'
          })
        })
      }).catch(() => {

        context.templates = window.xp
      })
    },
    toggleCheckbox(data) {//alert("HELLO")
      $('#main_toggler').parent().removeClass('is-checked')
      let context = this
      let j = 0
      this.checklists.map(function (el, index) {
        if (el.Id == data.Id) {
          if (el['Checked'] == false) {
            el['Checked'] = true
            context.idList.push(data.Id)
            context.itemsSelected = context.itemsSelected + 1
          } else {
            el['Checked'] = false
            context.itemsSelected = context.itemsSelected - 1
            if (context.idList.indexOf(data.Id) > -1) {
              context.idList.splice(context.idList.indexOf(data.Id), 1)
            }
          }
        }
      })
    },
    //FG - FOOF - Feb 6 2019 --- REMOVE THE FUNC. BELOW IF YOU DON'T SEE THE ALERT AFTER 
    //     SOME DECENT TESTING
    GetChemicalChecklist(id) {
      alert("ChemicalChecklist/chemicalsettings.controller.js")
      let context = this
      loader.startLoader()
      service.GetChemicalChecklist(id).then(function (response) {
        
        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {
          context.checklists = []
          loader.stopLoader()
          return;
        }

        loader.stopLoader()
        context.checklists = response ? response : []
        tooltip.startTooltip(50)
        context.checklistsBackup = deepcopy(response ? response : [])

      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    GetTemplates(id) {
      let context = this
      loader.startLoader()
      service.GetTemplates(id).then(function (response) {
        
        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {
          context.templates = []
          loader.stopLoader()
          return;
        }

        loader.stopLoader()
        context.templates = response ? response : []
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    deletedSelected() {
      this.del(this.idList)
    },
    copySelected() {
      this.copy(this.idList)
    },

    //FG - FOOF - After Cert - First Release (6) - rewrote delete code below to use new methods in hydrowareCommonJS.js
    //The delete function below deletes a row from the table
    del(item){
      let context = this
      var ID = item.row.Id
      var opts = {message: 'Are you sure you want to delete ' + item.row.Name + '?'}
      context.$hydrowareCommonJS.displayConfirmDeletePopup(context, opts, context.deleteTemplateRow.bind(null,ID))
    },
    deleteTemplateRow(ID) {
      var context = this;
      loader.startLoader()
      service.DeleteChemicalChecklist(ID).then(function (response) {
        
        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {
          loader.stopLoader()
          return;
        }

        context.$hydrowareCommonJS.notifyDeleteSuccess(context);
        context.GetTemplates(context.locationId)
        loader.stopLoader()
      },
      (error) => {
        loader.stopLoader()
        context.$hydrowareCommonJS.notifyError(context,{message: error.responseJSON.Message})
      })
    },

    someMethod(p1, p2) {
      alert('p1: '+p1 + ' / p2: ' + p2)
    },
    editATemplate(data, anotherParm) {
      this.templateData.isEdit = true
      //this.templateData.tid = data.Id  vvvvvv
      this.templateData.templateId = data.Id
      //FG - FOOF - Jan 23 2019 - I added "this" (which is this instance of
      //     chemicalsettings.controller.js) the template data that is passed
      //     along to the readings_maintenance.controller.js and 
      //     readings_maintenance.vue files so we have access to all of its
      //     functions and variables.
      this.templateData.chemsettingscontroller = this
      this.displayingTabbedPanes = true
    },
    copy: function (data) {
      let context = this
      context.$confirm('Are you sure you want to copy this template ?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        loader.startLoader()
        service.CopyChemicalChecklist(data).then(function (response) {
          
          //Is this restricted ? -- FG - After Cert - First Release Security
          if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {
            loader.stopLoader()
            return;
          }

          loader.stopLoader()
          context.$notify({
            title: 'Success',
            message: 'Copied  Successfully',
            type: 'success'
          })
          context.itemsSelected = 0
          context.GetTemplates(context.locationId)
        }, (error) => {
          loader.stopLoader()
          this.$notify({
            title: 'Error',
            message: error.responseJSON.Message,
            type: 'error'
          })
        })
      }).catch(() => {})
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
  watch: {
    displayingTabbedPanes: function (val) {
      this.$router.app.$emit('sidebar_hide', val)
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/ChemicalChecklist/chemicalsettings.controller.js